import { organizationFragment } from "./UpsertOrganizationFragments";
import client from "lib/apolloClient/client";

export const getOrganizationFeedDetailsFromCacheLocal = queryVars => {
  let queryData = {};
  const { id: organizationId } = queryVars;

  try {
    queryData = client.readFragment({
      id: `Organization:${organizationId}`,
      fragment: organizationFragment.organisationFeedDetails,
      variables: queryVars,
      fragmentName: "organisationFeedDetailsItem",
    });
  } catch (e) {
    return {};
  }
  return queryData;
};
